import QRCodeStyling from "styled-qr-code"
import logo from '@/assets/qrcode.logo.border.svg'
// import logo from '@/assets/logo-icon.svg'

class QrCodeGenerator {
  async generateQrCode(url, name, type) {
    type = type || 'png'

    // url = 'https://google.com'
    console.log(url)
    console.log(url.length)

    const qrCode = new QRCodeStyling({
      width: 1000,
      height: 1000,
      type: 'svg',
      image: logo,
      data: url,
      margin: 5,
      dotsOptions: {
        color: 'black',
        type: 'dots'
      },
      cornersDotOptions: {
        type: 'dot'
      },
      cornersSquareOptions: {
        type: 'extra-rounded'
      }
      // qrOptions: {
      //   typeNumber: 0,
      //   errorCorrectionLevel: 'H'
      // }
    })

    await qrCode.download({
      name: name.replace(/[^a-zA-Z0-9]+/g, '-'),
      extension: 'png'
    }, 1.0)
  }
}

export default (new QrCodeGenerator())